import { graphql } from 'react-relay';

export const performanceOverviewChartFragment = graphql`
    fragment PerformanceOverviewChart_chart on PerformanceOverviewChart {
        datepicker {
            ...Datepicker_text
        }
        datepickerbuttontexts
    }
`;
